export default __webpack_public_path__ + "static/media/5.73e7770b.jpg";